import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getcomplaintAPi,deletecomplaintApi } from "../../../ApiUrl";
export const token = sessionStorage.getItem("accessToken")

const headers = {
    Authorization: `Bearer ${token}`,   
};

// get complaint
export const getcomplaint = createAsyncThunk('getcomplaint/complaint', async () => {
    try {
        const response = await axios.get(`${getcomplaintAPi}?limit=`, { headers });
        return response.data; // Assuming your API response contains a 'complaints' property
    } catch (error) {
        throw new Error(error.message);
    }
});

// delete complaint
export const deletecomplaints = createAsyncThunk('deletecomplaints/complaint', async (complaintid, { rejectWithValue }) => {
    try {
        const response = await axios.delete(`${deletecomplaintApi}/${complaintid}`, { headers });
        return response.data._id; // Assuming your API response contains a 'complaintid' property
    } catch (error) {
        return rejectWithValue(error.response.data.message);
    }
});



const complaintSlice = createSlice({
    name: 'complaint',
    initialState: {
        complaints: [],
        status: 'idle',
        error: null,
        message: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            //getcomplaints
            .addCase(getcomplaint.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getcomplaint.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.complaints = action.payload;
            })
            .addCase(getcomplaint.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            })

            //delete complaints
            .addCase(deletecomplaints.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(deletecomplaints.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.complaints.data = state.complaints.data.filter(complaints => complaints.complaintid !== action.payload);
                state.status = 'idle'
            })
            .addCase(deletecomplaints.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            });
    }
});

export default complaintSlice.reducer;
